<template>
  <div id="" class="">
      <el-dialog title="上传文件" :visible.sync="isShowdialog" width="60%" @open="initData" @closed="cancel">
        <el-form ref="form" label-width="110px" size="mini" >
          <el-row style="display: flex;justify-content: center">
            <el-form label-position="top" >
              <div class="form-row">
                <el-form-item :label="'上传文件(' + groupData.type + ')'">
                  <el-upload
                    action="#"
                    :on-change="handleMediaChange"
                    :auto-upload="false"
                    :file-list="currentFiles"
                    list-type="picture-card"
                    :multiple="groupData.type === 'image'"
                    :before-remove="removeFilesItem"
                    :accept="groupData.type === 'image' ? 'image/*' : groupData.type === 'video' ? 'video/*' : 'audio/*'"
                  >
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}" style="height: 100%">
                      <el-image
                        class="el-upload-list__item-thumbnail"
                        :src="file.url" alt=""
                        fit="fill"
                      >
                      </el-image>
                      <span class="el-upload-list__item-actions">
                        <span
                          class="el-upload-list__item-preview"
                          @click="handlePictureCardPreview(file)"
                        >
                          <i class="el-icon-zoom-in"></i>
                        </span>
                        <span
                          v-if="!disabled"
                          class="el-upload-list__item-delete"
                          @click="removeFilesItem(file)"
                        >
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                  </el-upload>
                  <el-dialog :visible.sync="imageDialogVisible" :append-to-body="true">
                    <img width="100%" :src="dialogImageUrl" alt="">
                  </el-dialog>
<!--                  <div class="media-preview" v-if="currentFiles.length > 0">-->
<!--                    <div v-if="groupData.type === 'image'" style="display: flex;flex-wrap: wrap;">-->
<!--                      <div v-for="(file,index) in currentFiles" :key="index" style="margin-right: 10px;position: relative">-->
<!--                        <div class="close-item"><i class="el-icon-circle-close" @click="removeFilesItem(index)"></i></div>-->
<!--                        <img v-if="file.mediaUrl" :src="file.mediaUrl" class="preview-image" />-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div v-else-if="groupData.type === 'video'" style="position: relative">-->
<!--                      <div class="close-item"><i class="el-icon-circle-close" @click="removeFilesItem(0)"></i></div>-->
<!--                      <video v-if="currentFiles[0].mediaUrl" controls class="preview-video">-->
<!--                        <source :src="currentFiles[0].mediaUrl" />-->
<!--                      </video>-->
<!--                    </div>-->

<!--                  </div>-->
                </el-form-item>
              </div>
            </el-form>
          </el-row>
          <el-row style="display:flex;justify-content: flex-end">
            <el-form-item size="mini">
              <el-button type="primary" @click="onSubmit">确定</el-button>
              <el-button @click="cancel">取消</el-button>
            </el-form-item>
          </el-row>
        </el-form>
      </el-dialog>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  props:['dialogVisible','groupData'],
  watch: {
    dialogVisible(val){
      this.isShowdialog = val;
    },
    groupData(val){
      //this.initData()
    }
  },
  data() {
    return {
      isShowdialog: false,
      dialogTitle: '',
      returnTime: '',
      uploading: '',
      options: [{
        value: 'image',
        label: '图片'
      }, {
        value: 'video',
        label: '视频'
      }, {
        value: 'audio',
        label: '音频'
      }],
      groupForm: {
        groupName: '',
        type: ''
      },
      needDelImages: [],
      currentImages: [], //当前冗余图片数组
      currentFiles:[],

      dialogImageUrl: '',
      imageDialogVisible: false,
      disabled: false
    }
  },
  methods:{
    cancel(done){
      this.needDelImages = [];
      this.currentImages = []; //当前冗余图片数组
      this.currentFiles = [];
      this.isShowdialog = false;
      this.$emit('change-state',{isShow: this.isShowdialog,dialog:'nfc'})
    },
    async onSubmit() {
      this.uploading = this.$loading({
        lock: true,
        text: '拼命加载中...',
      });

      try{
        const updateFiles = this.groupData['fileUrls']; //获取当前文件数组
        const formData = new FormData();
        this.currentFiles.forEach(item => {
          // 如果是本地文件需要上传
          if(item.mediaFile) formData.append('uploadFiles',item.mediaFile)
        });
        const uploadFileRes = await this.$request.file_upload('nfcDir',formData);
        //console.log(uploadFileRes);

        if(uploadFileRes.code === 0){
          if(this.needDelImages.length > 0){
            const del_fils = this.needDelImages.map((file) => {
              const index = updateFiles.indexOf(file.fileName);
              if (index !== -1) {
                updateFiles.splice(index,1); //去掉已删除文件
              }
              return `upload/${file.fileName}`
            })
            await this.$request.drop_files(del_fils);
          }

          uploadFileRes.data.forEach((uploadFile) => {
            updateFiles.push(uploadFile.filename); //塞进数组中
          })

          const updateGroupRes = await this.$request.create_group({
            id: this.groupData._id,
            fileUrls: updateFiles
          })
          if(updateGroupRes.code === 0){
            this.$message('上传文件夹成功');
          }else{
            this.$message(updateGroupRes['errMsg']);
          }
        }

      } catch(e) {
        this.$message(e);
      } finally {
        this.uploading.close();
        this.isShowdialog = false;
        this.$emit('change-state',{isShow: this.isShowdialog,dialog:'nfc',refresh:true})
      }
    },

    handleMediaChange(file) {
      if(this.groupData.type === 'audio' && this.currentFiles.length > 1){
        this.$message('只能上传一个音频文件');
        return;
        // 获取文件类型（图片/视频）
        //const fileType = file.raw.type.startsWith('image') ? 'image' : file.raw.type.startsWith('video') ? 'video' : 'audio';
      }
      if(this.groupData.type === 'video' && this.currentFiles.length > 1){
        this.$message('只能上传一个视频文件');
        return;
      }
      if(this.groupData.type === 'image' && this.currentFiles.length > 9){
        this.$message('只能上传九个图片文件');
        return;
      }
      // 本地预览
      this.currentFiles.push({
        mediaUrl: file.url,
        url: file.url,
        mediaFile: file.raw
      })
    },

    initData(){
      const files = this.groupData['fileUrls'];
      if(files){
        files.forEach( file => {
          this.currentFiles.push(
            {
              url:this.$config.upload_file_url + file,
              mediaUrl: this.$config.upload_file_url + file,
              fileName: file,
              mediaFile: ''
            }
          )
        })
      }
    },

    // removeFilesItem(index) {
    //   if(this.currentFiles[index].mediaUrl.includes(this.$config.upload_file_url) || this.currentFiles[index].fileName){
    //     this.needDelImages.push(this.currentFiles[index])
    //   }
    //   this.currentFiles.splice(index, 1);
    // },
    removeFilesItem(file) {
      let index = -1
      for(const [idx,item] of this.currentFiles.entries()){
        if(item.fileName === file.fileName){
          index = idx;
          break;
        }
      }
      if(index !== -1){
        console.log(this.currentFiles[index].mediaUrl.includes(this.$config.upload_file_url) , this.currentFiles[index].fileName)
        if(this.currentFiles[index].mediaUrl.includes(this.$config.upload_file_url) || this.currentFiles[index].fileName){
          this.needDelImages.push(this.currentFiles[index])
        }
        this.currentFiles.splice(index, 1);
      }
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imageDialogVisible = true;
    },

  },
}
</script>

<style>
.form-row {
  margin-bottom: 15px;
}

.media-preview {
  margin-top: 15px;
}

.preview-image {
  max-width: 100%;
  max-height: 200px;
  display: block;
}
.preview-video {
  max-width: 100%;
  max-height: 200px;
  display: block;
}
.close-item{
  position: absolute;
  top: 0;
  right: 6px;
  line-height: 0;
  font-size: 20px;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/UploadFilesDialog.vue